import type React from "react";
import ProgressBar from "./ProgressBar";

interface ConfidenceBarProps {
	confidence: number;
	tone?: "primary" | "green";
	widthClassName?: string;
}

const ConfidenceBar: React.FC<ConfidenceBarProps> = ({ confidence, tone = "primary", widthClassName = "w-20" }) => {
	const percentage = Math.max(0, Math.min(100, Math.round(confidence * 100)));

	return (
		<div className="flex items-center space-x-2">
			<ProgressBar value={percentage} tone={tone} className={widthClassName} />
			<span className="text-xs text-muted w-10 text-right">{percentage}%</span>
		</div>
	);
};

export default ConfidenceBar;
